import { IDataHandler } from '../IDataHandler';
import { TransactionTrackingEventName, ResourceTrackingEventName, allTrackingEvents, FarmTrackingEventName } from '../TrackingEvent';
import { TransactionDataSet } from '../DataSet/Transaction';

type tDataSetKey = keyof TransactionDataSet;

export const TransactionDataMap: Map<allTrackingEvents, tDataSetKey[]> = new Map<allTrackingEvents, tDataSetKey[]>([
    [
        ResourceTrackingEventName.resource,
        [
            'transactionType',
            'tGameArea',
            'tActionType',
            'tLevelContext',
            'tCardsLeft',
            'transactionID',
            'tCoinsLevelEntry',
            'tCoinsLevelEnd',
            'tAdCoins',
            'tIAPCoins',
            'tTNTActive',
        ],
    ],
    [
        TransactionTrackingEventName.transaction,
        [
            'tProductID',
            'tPurchaseStatus',
            'tPurchaseFailReason',
            'transactionType',
            'tGameArea',
            'tActionType',
            'tLevelContext',
            'tCardsLeft',
            'transactionID',
            'productsSpent',
            'productsReceived',
            'tTNTActive'
        ],
    ],
    [
        FarmTrackingEventName.myFarmUpdate,
        [
            'productsSpent',
            'productsReceived',
        ],
    ]
]);

export class TransactionDataHandler implements IDataHandler<TransactionDataSet> {
    public data: TransactionDataSet = new TransactionDataSet();

    public getEventData(eventName: allTrackingEvents): TransactionDataSet {
        const data: TransactionDataSet = TransactionDataMap.get(eventName).reduce((acc, key) => {
            acc[key] = this.data[key] as never;
            return acc;
        }, {} as TransactionDataSet);

        // Reset data.
        if (eventName === TransactionTrackingEventName.transaction) {
            this.data = new TransactionDataSet();
        }
        if (eventName === ResourceTrackingEventName.resource) {
            this.data.tAdCoins = 0;
            this.data.tCoinsLevelEntry = 0;
            this.data.tCoinsLevelEnd = 0;
        }
        if (eventName === FarmTrackingEventName.myFarmUpdate) {
            this.data.productsReceived = undefined;
            this.data.productsSpent = undefined;
        }
        this.data.tGameArea = data.tGameArea;

        return data;
    }

    public clearData(): void {
        this.data = new TransactionDataSet();
    }
}
